import { createTheme } from "@material-ui/core/styles";

export default createTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: "#2196F3",
            light: "#4dabf5",
            dark: "#1769aa",
            contrastText: "#ffffff"
        },
        secondary: {
            main: "#424242",
            light: "#676767",
            dark: "#2e2e2e",
            contrastText: "#ffffff"
        },
        customtab: {
            main: "#FFFFFF",
            light: "#FFFFFF",
            dark: "#D84315",
            contrastText: "#ffffff"
        }
    },
    overrides: {
        MuiDialogTitle: {
            root: {
                padding: "15px 24px 8px"
            }
        },
        MuiInput: {
            root: {
                fontSize: 14
            },
            underline: {
                "&:hover:before": { //underline color when hovered
                    borderColor: "#2196F3"
                },
                "&:hover:after": { //underline color when hovered
                    borderColor: "#2196F3"
                },
                "&:hover:not($disabled):after": { //underline color when hovered
                    borderColor: "#2196F3"
                }
            }
        },
        MuiFormLabel: {
            root: {
                "&$focused": {
                    color: "#2196F3"
                }
            }
        },
        MuiInputLabel: {
            root: {
                fontSize: 14
            }
        },
        MuiListItemText: {
            primary: {
                fontSize: 14
            }
        },
        MuiTableRow: {
            root: {
                "&$selected": {
                    backgroundColor: "white"
                }
            }
        },
        MuiCheckbox: {
            colorPrimary: {
                "&$checked": {
                    color: "#2196F3"
                }

            }
        },
        MuiTabs: {},
        MuiTab: {
            root: {
                fontSize: 14,
                fontWeight: 400,
                fontFamily: "Roboto",
                "&$selected": {
                    color: "#2196F3",
                    fontWeight: 500
                }
            }
        },
        MuiSelect: {
            select: {
              "&:focus": {
                'background-color': "unset"
              }
            }
        }
    }
});
